import { Box, Text, Link, Image } from "@chakra-ui/react";
import Route from "./common/route";
import { useRouter } from "next/router";
import { GetCookie } from "../provider/common";

// ========== 데이터 함수들 ===========

export const description = (data) => {
  let _manufacturer = data.manufacturer;
  let _description = data.description;
  let _pn = data.pn;
  return (
    <Text fontSize="12px" color="gray">
      {_manufacturer === ""
        ? `${_pn}--${_description}`
        : _pn === ""
        ? `${_manufacturer}--${_description}`
        : _description}
    </Text>
  );
};

export const Goto = (pics, data, isLoginCheck, keyword) => {
  const router = useRouter();
  const axios = require("axios").default;
  const CombineBotAsked = async () => {
    // 로그인이 되어있으면 견적바구니로 바로 요청
    if (isLoginCheck === "1") {
      const body = [];

      body.push({
        it_id: data.it_id,
        it_brand: data.manufacturer,
        it_name: data.pn,
        it_maker: data.source,
        qty: pics.stock,
      });

      try {
        const URL = process.env.PANDA_API_URL + "/api/mall/insertQuoteLists";
        const result = await axios.post(URL, body, {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${await GetCookie("token")}`,
          },
        });
        if (result.data.status === 200) {
          if (
            confirm(
              "견적바구니에 저장되었습니다. 견적바구니로 이동하시겠습니까?"
            ) === true
          ) {
            router.push(`/marketplace/cart`);
            return;
          }
        } else {
          alert("견적바구니에 저장이 실패하였습니다.");
        }
      } catch (e) {
        console.log(e);
        alert("견적바구니에 저장이 실패하였습니다.");
      }
    } else {
      const basePath = `/search/lists?keyword=${keyword}`;
      const href = `/auth/login?before=${basePath}`;
      router.push(href);
    }
    // 미 로그인 되어있으면 로그인 화면으로 간다.
  };

  if (pics.source === "partner") {
    return (
      <Link
        className={`flex-center`}
        style={{ margin: "0 5px" }}
        bg="#111"
        _hover={{ bg: "#71717b;" }}
      >
        <Box onClick={() => CombineBotAsked()}>판다봇 견적요청</Box>
      </Link>
    );
  } else if (
    pics.source === "pandaparts" &&
    pics.item_price !== undefined &&
    pics.item_price !== 0
  ) {
    return (
      <Link
        className="flex-center"
        href={`/parts/mallview/${pics.it_id}`}
        bg="#E53E3E"
        _hover={{ bg: "#c0392b" }}
      >
        구매하러가기
      </Link>
    );
  } else if (Number(pics.stock) === 0 || Number(pics.price) === 0) {
    return (
      <Link style={{ margin: "0 5px" }} bg="#111" _hover={{ bg: "#71717b;" }}>
        <Box onClick={() => CombineBotAsked()}>판다봇 견적요청</Box>
      </Link>
    );
  } else if (pics.source === "pandaparts") {
    return (
      <Link
        className="flex-center"
        href={`/parts/view/ON${pics.stock_no}`}
        bg="#E53E3E"
        _hover={{ bg: "#c0392b" }}
      >
        구매하러가기
      </Link>
    );
    // 디지키가 아니면서 아날로그 디바이스이면 컴바인봇 견적 문의하기
  } else if (data.manufacturer.toLowerCase().includes("analog device")) {
    return (
      <Link style={{ margin: "0 5px" }} bg="#111" _hover={{ bg: "#71717b;" }}>
        <Box onClick={() => CombineBotAsked()}>판다봇 견적요청</Box>
      </Link>
    );
  } else {
    return (
      <Link
        className="flex-center"
        href={`/parts/view/PD${pics.stock_no}`}
        bg="#E53E3E"
        _hover={{ bg: "#c0392b" }}
      >
        구매하러가기
      </Link>
    );
  }
};
export const period = (data) => {
  if (data.recent_period + data.add_days !== 0) {
    return (
      <>
        <Text>
          {data.recent_period}~{data.recent_period + data.add_days}일
        </Text>
        <Text className="search-list_export">국내출고 예정</Text>
      </>
    );
  } else {
    return (
      <Text textAlign="center" width="50px">
        미정
      </Text>
    );
  }
};

export const periodFigma = (data) => {
  if (data.recent_period + data.add_days !== 0) {
    if (data.location === "국내") {
      return (
        <>
          <div>1~3</div>
        </>
      );
    }
    return (
      <>
        <div>
          {data.recent_period}~{data.recent_period + data.add_days}
        </div>
      </>
    );
  } else {
    return <div>미정</div>;
  }
};

export const periodNoDiv = (data) => {
  if (data.recent_period + data.add_days !== 0) {
    if (data.location === "국내") {
      return "1~3";
    }
    return data.recent_period + "~" + (data.recent_period + data.add_days);
  } else {
    // 없으면 기본값
    return "3~5";
  }
};

export const logo = (data) => {
  let logo_url = "";
  let width = "";
  switch (data.source) {
    case "mouser":
      logo_url = "/images/brand/search/mouser_logo.png";
      break;
    case "digikey":
      logo_url = "/images/brand/search/digikey_logo.png";
      break;
    case "arrow":
      logo_url = "/images/brand/search/arrow_logo.png";
      break;
    case "verical":
      logo_url = "/images/brand/search/verical_logo.png";
      break;
    case "onechip":
      logo_url = "/images/brand/search/onechip_logo.png";
      break;
    case "dfrobot":
      logo_url = "/images/brand/search/dfrobot_logo.png";
      break;
    case "seeed":
      logo_url = "/images/brand/search/seedstudio_logo.png";
      break;
    case "pandaparts":
      logo_url = "/images/brand/search/pandaparts_logo.png";
      break;
    case "future":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "corestaff":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "pei":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "partner":
      logo_url = "/images/brand/search/partner_logo.png";
      break;
    default:
      logo_url = "/images/no_img.png";
      break;
  }
  return (
    <>
      {data.source === "partner" || data.source === "pandaparts" ? (
        <Image className="search_item_logo_except" src={logo_url} />
      ) : data.source === "digikey" ? (
        <Image src={logo_url} />
      ) : (
        <Image src={logo_url} />
      )}
    </>
  );
};

export const logoUrl = (data) => {
  let logo_url = "";
  let width = "";
  switch (data.source) {
    case "mouser":
      logo_url = "/images/brand/search/mouser_logo.png";
      break;
    case "digikey":
      logo_url = "/images/brand/search/digikey_logo.png";
      break;
    case "arrow":
      logo_url = "/images/brand/search/arrow_logo.png";
      break;
    case "verical":
      logo_url = "/images/brand/search/verical_logo.png";
      break;
    case "onechip":
      logo_url = "/images/brand/search/onechip_logo.png";
      break;
    case "dfrobot":
      logo_url = "/images/brand/search/dfrobot_logo.png";
      break;
    case "seeed":
      logo_url = "/images/brand/search/seedstudio_logo.png";
      break;
    case "pandaparts":
      logo_url = "/images/brand/search/pandaparts_logo.png";
      break;
    case "future":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "corestaff":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "pei":
      logo_url = "/images/brand/search/alliance_logo.png";
      break;
    case "partner":
      logo_url = "/images/brand/search/partner_logo.png";
      break;
    default:
      logo_url = "/images/no_img.png";
      break;
  }
  return logo_url;
};
